import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment'

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        // '&:nth-of-type(odd)': {
        //     backgroundColor: theme.palette.background.default,
        // },
    },
}))(TableRow);

function createData(ymd, value, qoq, yoy, yyoy) {
    return { ymd, value, qoq, yoy, yyoy};
}


const useStyles = makeStyles((theme) => ({
    table: {
      minWidth: 250,
      backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000"
    },
    button1: {
      minWidth: 110,
    }
  }));

export default function RevList(props) {
    const classes = useStyles();
    const [buyselldata, setBuyselldata] = React.useState([]);

    useEffect(() => {
        if(props.open) fectchStockData(props.stockId)
    }, [props.stockId]);


    function fectchStockData(stockId) {
        if(stockId != null) {
            let a = {
                sid: stockId
            };

            fetch("/jstock/v1/stock/revlist", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(a)
            })
                .then(res => res.json())
                .then(
                    result => {
                        let dd = result.r.map(row =>
                            createData(moment(row.ym, "YYYYMM").format('YYYY/MM'), row.tsrev_month, row.sqoq.toFixed(2), row.syoy.toFixed(2), row.tsaccdiffp.toFixed(2))
                        )
                        setBuyselldata(dd)
                    },
                    error => {
                    }
                );
        }
    }

    function getColor(value) {
        if(value >= 0) {
            return "#f7456c"
        }
        else {
            return "#7bbd4f"
        }
    }

    

    return (
        <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">營收表</DialogTitle>

            <DialogContent>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table" size="small">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>年月</StyledTableCell>
                                <StyledTableCell align="center">營收</StyledTableCell>
                                <StyledTableCell align="center">月MoM</StyledTableCell>
                                <StyledTableCell align="center">月YoY</StyledTableCell>
                                <StyledTableCell align="center">年累積YoY</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {buyselldata.map(row => (
                                <StyledTableRow key={row.ymd}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.ymd}
                                    </StyledTableCell>
                                    <StyledTableCell align="right"  align="right">
                                        {(row.value/1000000).toFixed(0)}百萬
                                    </StyledTableCell>
                                    <StyledTableCell align="right" style={{color: getColor(row.qoq) }} align="right">
                                        {row.qoq}%
                                    </StyledTableCell>
                                    <StyledTableCell align="right"  style={{color: getColor(row.yoy) }} align="right">
                                        {row.yoy}%
                                    </StyledTableCell>
                                    <StyledTableCell align="right"  style={{color: getColor(row.yyoy) }} align="right">
                                        {row.yyoy}%
                                    </StyledTableCell>  

                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={props.handleClose} color="primary">
                    取消
          </Button> */}
                <Button onClick={props.handleClose} color="primary">
                    關閉
          </Button>
            </DialogActions>
        </Dialog>
    );
}
